import React, { useContext } from 'react';
export var locales = {
  isEnglish: true
};
var LanguageContext = /*#__PURE__*/React.createContext();
export default LanguageContext;